var _path, _path2, _path3, _circle, _circle2, _circle3, _ellipse, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3964FF",
    d: "M182.813 56.25h63.281v35.156h-63.281zM182.813 274.219h63.281v35.156h-63.281z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#839DFC",
    d: "M119.531 56.25h63.281v35.156h-63.281zM119.531 274.219h63.281v35.156h-63.281zM324.516 86.63l-61.68 14.145-7.859-34.267 61.68-14.145zM373.23 299.088l-61.68 14.145-7.859-34.267 61.68-14.145z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C77FF",
    d: "M49.219 119.531h70.313v14.063H49.219zM49.219 309.375h70.313v14.063H49.219z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.453,
    cy: 179.297,
    r: 24.609,
    fill: "#3964FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 151.172,
    cy: 179.297,
    r: 24.609,
    fill: "#839DFC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.311,
    cy: 179.384,
    r: 24.609,
    fill: "#839DFC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.375,
    cy: 217.969,
    fill: "#708EFC",
    rx: 21.094,
    ry: 63.281
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#284172",
    d: "M386.719 346.563h-21.026l17.504-4.014a4.999 4.999 0 0 0 3.756-5.99L312.644 12.494a4.997 4.997 0 0 0-5.99-3.756l-55.56 12.74v-7.415a5 5 0 0 0-5-5H119.532a5 5 0 0 0-5 5v65.313H49.219a5 5 0 0 0-5 5v262.188h-2.031a5 5 0 1 0 0 10h9.062v30.156a5 5 0 1 0 10 0v-30.156h257.596a5 5 0 0 0 1.552.257c.373 0 .748-.042 1.117-.127l.566-.13H332.5v30.156c0 2.762 2.238 5 5 5s5-2.238 5-5v-30.156h44.219a5 5 0 0 0 0-10.001zm-82.704-326.96 72.073 314.317-51.934 11.908L252.082 31.51l51.933-11.907zm10.049 326.96h-62.97V71.942l62.97 274.621zM54.219 89.375h60.313v257.188H54.219V89.375zm70.312-5V19.063h53.281v327.5h-53.281V84.375zm63.282 262.188v-327.5h53.281v327.5h-53.281zm-159.688 0H14.063a5 5 0 1 0 0 10h14.063a5 5 0 1 0-.001-10z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.86db35c5ef0288f92c063bceaeef52e9.svg";
export { ForwardRef as ReactComponent };